export enum Commands {
    SPIN = "SPIN",
    SKIP = "SKIP",
    START_AUTOPLAY = "START_AUTOPLAY",
    STOP_AUTOPLAY = "STOP_AUTOPLAY",
    DECREMENT_AUTOPLAY = "DECREMENT_AUTOPLAY",
    CLEAR_AUTOPLAY_LIMITS = "CLEAR_AUTOPLAY_LIMITS",
    SET_AUTOPLAY_LOSS_LIMIT = "SET_AUTOPLAY_LOSS_LIMIT",
    SET_AUTOPLAY_SINGLE_WIN_LIMIT = "SET_AUTOPLAY_SINGLE_WIN_LIMIT",
    SET_AUTOPLAY_TOTAL_WIN_LIMIT = "SET_AUTOPLAY_TOTAL_WIN_LIMIT",
    TOGGLE_AUTOPLAY_STOP_ON_FEATURE_WIN = "TOGGLE_AUTOPLAY_STOP_ON_FEATURE_WIN",
    TOGGLE_AUTOPLAY_STOP_ON_ANY_WIN = "TOGGLE_AUTOPLAY_STOP_ON_ANY_WIN",
    TOGGLE_AUTOPLAY_STOP_ON_BIG_WIN = "TOGGLE_AUTOPLAY_STOP_ON_BIG_WIN",
    TOGGLE_AUTOPLAY_SETTINGS = "TOGGLE_AUTOPLAY_SETTINGS",
    TOGGLE_AUTOPLAY_POPUP = "TOGGLE_AUTOPLAY_POPUP",
    TOGGLE_BET_SETTINGS = "TOGGLE_BET_SETTINGS",
    TOGGLE_BET_POPUP = "TOGGLE_BET_POPUP",
    TOGGLE_SETTINGS = "TOGGLE_SETTINGS",
    TOGGLE_PAYTABLE = "TOGGLE_PAYTABLE",
    CLOSE_SETTINGS = "CLOSE_SETTINGS",
    UPDATE_UI = "UPDATE_UI",
    UPDATE_WIN = "UPDATE_WIN",
    BANGUP_WIN = "BANGUP_WIN",
    CLEAR_WIN = "CLEAR_WIN",
    UPDATE_TEMP_WIN = "update_temp_win",
    SET_MAX_BET = "SET_MAX_BET",
    SET_BET = "SET_BET",
    SAVE_SETTINGS = "SAVE_SETTINGS",
    CYCLE_STAKE_VALUE = "CYCLE_STAKE_VALUE",
    CYCLE_BET_VALUE = "CYCLE_BET_VALUE",
    CYCLE_LINES_NUMBER = "CYCLE_LINES_NUMBER",
    CYCLE_COIN_VALUE = "CYCLE_COIN_VALUE",
    CYCLE_TOTAL_BET = "CYCLE_TOTAL_BET",
    TOGGLE_SOUND_FX = "TOGGLE_SOUND_FX",
    TOGGLE_MUSIC = "TOGGLE_MUSIC",
    TOGGLE_MASTER_SOUND = "TOGGLE_MASTER_SOUND",
    SET_MASTER_VOLUME = "SET_MASTER_VOLUME",
    TOGGLE_SPACE_TO_SPIN = "TOGGLE_SPACE_TO_SPIN",
    TOGGLE_TURBO_SPIN = "TOGGLE_TURBO_SPIN",
    UPDATE_BALANCE = "UPDATE_BALANCE",
    REQUEST_HISTORY = "REQUEST_HISTORY",
    SHOW_HISTORY = "SHOW_HISTORY",
    HIDE_HISTORY = "HIDE_HISTORY",
    SHOW_ERROR = "SHOW_ERROR",
    GO_HOME = "GO_HOME",
    UPDATE_INFO_BAR = "UPDATE_INFO_BAR",
    UPDATE_FREE_GAMES = "UPDATE_FREE_GAMES",
    UPDATE_FREE_SPINS = "UPDATE_FREE_SPINS",
    CLEAR_FREE_SPINS = "CLEAR_FREE_SPINS",
    OPEN_RC_HISTORY = "OPEN_RC_HISTORY",
}
